import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const CertifiedIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0597 19.8507C15.7291 18.7387 19.968 14.8918 19.968 7.99148C19.968 7.38722 19.6047 6.84222 19.0469 6.6098L13.0597 4.11514C12.6913 3.96162 12.2768 3.96162 11.9083 4.11514L5.92112 6.6098C5.36334 6.84221 5 7.38721 5 7.99148C5 14.181 8.57034 18.4601 11.9083 19.8507C12.2767 20.0043 12.6912 20.0043 13.0597 19.8507ZM12.4861 17.9186L12.484 17.9175V6.03731L17.9686 8.32258C17.8651 13.0444 15.409 16.4627 12.4861 17.9186Z"
      />
    </Icon>
  );
};
